import { useQuery } from "@tanstack/react-query";
import axiosAuth from "../axiosAuth";
import { FISCAL_YEAR_API } from "./apiRoutes";

const fetchLifeCycle = async (communityId: string | number) => {
  const res = await axiosAuth.get(`${FISCAL_YEAR_API(communityId)}/`);
  return res.data;
};

const useGetLifeCycle = ({communityId,
    queryParams,
}: {
    communityId?: string | number;
    queryParams?:any
}) =>
  useQuery({
    queryKey: ["fiscal-year-lifecycle", communityId],
    queryFn: () => fetchLifeCycle(communityId!),
    select: (data: any) => data.data,
    enabled: !!communityId ,
    ...queryParams
  });

export default useGetLifeCycle;